export function logout(send) {
  return (...args) =>
    send(
      {
        path: '/v1/logout',
        pathParameters: {},
        type: 'post',
        query: undefined,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
